import { WyanokeUtil } from "../util/WyanokeUtil";


export class CompleteProfileModal {

    private static returnUrl: string = window.location.href;

    public static async init(): Promise<void> {
        const profile = await WyanokeUtil.loadUserProfile(true, false);
        if (!profile || profile.isLoggedIn === "False") {
            return;
        } else {
            this.checkSessionForModal();
        }

        window.addEventListener("globalsloaded", () => {
            this.checkSessionForModal();
        });
    }

    private static checkSessionForModal(): void {
        if (window.UserProfile !== undefined && window.UserProfile.isLoggedIn === "True" && window.UserProfile.completeuser === "False") {
            console.log('Checking sessionStorage for Healio.CompleteProfile.LastShown');
            const checkRequest = sessionStorage.getItem('Healio.CompleteProfile.LastShown');
            console.log('sessionStorage value:', checkRequest);
            if (checkRequest === null) {
                const isGoogle = (this.getCookie('googleauth') !== undefined);
                const isApple = (this.getCookie('appleauth') !== undefined);
                this.loadReminderModal(window.UserProfile.email, window.UserProfile.contactid, isGoogle, isApple);
            }
        }
    }

    public static loadReminderModal(email: string, contactId: string, isGoogleUser: boolean, isAppleUser: boolean): void {
        const checkRequest = sessionStorage.getItem('Healio.CompleteProfile.LastShown');
        if (checkRequest !== null) {
            console.log('Modal already shown in this session, skipping');
            return;
        }
        if (this.isPaidTraffic()) {
            console.log('Paid traffic (utm_medium=cpc), skipping modal');
            return;
        }
        if (this.returnUrl.includes("healio.com/community/") || this.returnUrl.includes("healio.com/mathematica/")) {
            console.log('Excluded URL, skipping modal');
            return;
        }

        const currentUrl = window.location.href;
        if (currentUrl.includes("healio.com/my-account/edit-profile")) {
            console.log('Excluded URL, skipping modal');
            return;
        }

        console.log('Loading reminder modal...');
        const regdata = {
            ContactId: contactId,
            EmailAddress: email,
            IsGoogleUser: isGoogleUser,
            IsAppleUser: isAppleUser
        };
        fetch("/loginregistration/modals/loadrequestmoremodal", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(regdata)
        })
        .then(response => response.text())
        .then(results => {
            console.log('Modal loaded successfully');
            $('#welcomeModal').modal('hide');
            $('#loginModal').modal('hide');
            $('body').append(results);

            // Set sessionStorage only once after successful modal load
            const sessionData = {
                contactid: window.UserProfile.contactid,
                timestamp: new Date().toISOString()
            };
            console.log('Setting sessionStorage with data:', sessionData);
            sessionStorage.setItem("Healio.CompleteProfile.LastShown", JSON.stringify(sessionData));
            console.log('sessionStorage after set:', sessionStorage.getItem('Healio.CompleteProfile.LastShown'));
        })
        .catch(err => {
            console.error('Error loading modal:', err);
        });
    }

    /**
     * Loads the reminder modal for incomplete profile users without setting cookies
     * Used specifically for BackNextButton integration
     */
    public static loadReminderModalForBackNext(email: string, contactId: string): void {
        if (this.isPaidTraffic()) {
            console.log('[CompleteProfileModal] - Paid traffic (utm_medium=cpc), skipping reminder modal for BackNextButton');
            return;
        }
        const regdata = {
            ContactId: contactId,
            EmailAddress: email
        };
        fetch("/loginregistration/modals/loadrequestmoremodal", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(regdata)
        })
        .then(response => response.text())
        .then(results => {
            console.log("[CompleteProfileModal] - Loading reminder modal for BackNextButton");
            $('#welcomeModal').modal('hide');
            $('#loginModal').modal('hide');
            $('body').append(results);
        })
        .catch(err => {
            console.error("[CompleteProfileModal] - Error loading reminder modal:", err);
        });
    }

    /** Matches ConsentBanner / H5-10530: do not show profile gate on paid CPC landings. */
    private static isPaidTraffic(): boolean {
        const urlParams = new URLSearchParams(window.location.search);
        const utmMedium = urlParams.get('utm_medium')?.toLowerCase();
        return utmMedium === 'cpc';
    }

    private static getCookie(name: string): string | undefined {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop()?.split(';').shift();
    }
}
